<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section v-if="isDataFetched" class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">
          <template v-if="isUpdateMode">バナー編集</template>
          <template v-else>バナー登録</template>
        </h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div
        v-if="errorMessage"
        class="error-message"
        style="white-space: pre-wrap"
      >
        {{ errorMessage }}
      </div>
      <table style="width: 80%">
        <thead>
          <th style="width: 3%"></th>
          <th style="width: 25%"></th>
          <th style="width: 10%"></th>
          <th style="width: 12%"></th>
          <th style="width: 3%"></th>
          <th style="width: 21%"></th>
          <th style="width: 25%"></th>
        </thead>
        <tbody>
          <tr>
            <td class="required-mark">※</td>
            <td class="form-control-title">バナー名</td>
            <td colspan="5">
              <input
                id="txtBannerName"
                v-model="bannerData.bannerName"
                type="text"
                placeholder="バナー名"
                maxlength="255"
                class="form-control"
                ref="txtBannerName"
              />
            </td>
          </tr>
          <tr>
            <td class="required-mark">※</td>
            <td class="form-control-title">リンクURL</td>
            <td colspan="5">
              <input
                id="kbannerUrlaisyaName"
                v-model="bannerData.bannerUrl"
                type="text"
                placeholder="リンクURL"
                maxlength="255"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <td class="required-mark"></td>
            <td class="form-control-title">バナー画像</td>
            <td>
              <div class="file-upload">
                <button
                  v-if="bannerData.bannerImgFileName"
                  class="btn btn-danger"
                  @click="onBannerImglClear()"
                >
                  クリア
                </button>
                <button
                  v-else
                  class="btn btn-primary"
                  @click="onContentsFileUpload()"
                >
                  参照
                </button>
                <input
                  type="file"
                  :accept="bannerImgFileExtensions.join(',')"
                  @change="handleContentsFileSelected"
                  ref="bannerImgFileInput"
                  style="display: none"
                />
              </div>
            </td>
            <td colspan="4">{{ bannerData.bannerImgFileName }}</td>
          </tr>
          <tr>
            <td class="required-mark"></td>
            <td class="form-control-title">キャプション</td>
            <td colspan="5">
              <input
                id="bannerCaption"
                v-model="bannerData.bannerCaption"
                type="text"
                placeholder="キャプション"
                maxlength="255"
                class="form-control"
              />
            </td>
          </tr>
          <tr>
            <td class="required-mark"></td>
            <td class="form-control-title">表示期間</td>
            <td colspan="2">
              <input
                id="dispDtFrom"
                v-model="bannerData.dispDtFrom"
                type="date"
                class="form-control"
                :max="AppConstants.MAX_DATE_VALUE"
              />
            </td>
            <td>～</td>
            <td>
              <input
                id="dispDtTo"
                v-model="bannerData.dispDtTo"
                type="date"
                class="form-control"
                :max="AppConstants.MAX_DATE_VALUE"
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>

      <br />
      <div class="form-inline flex-container" style="width: 80%">
        <button
          type="button"
          name="btnBack"
          class="btn btn-footer btn-primary"
          @click="onBack"
        >
          戻る
        </button>

        <button
          type="button"
          name="btnClear"
          class="btn btn-footer btn-primary"
          @click="onClear"
        >
          クリア
        </button>

        <button
          type="button"
          name="btnFixed"
          class="btn btn-footer btn-primary"
          @click="onFixed"
        >
          確定
        </button>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import * as tus from "tus-js-client"; // * as tus を使ってインポート
import { defineComponent, onMounted, ref, computed } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import {
  formatMessage,
  outputDebugLogs,
  scrollToTop,
  isTokenAlive,
  commonHandleAxiosError,
  sanitizeInput,
  checkFileName,
  hasNoGaiji,
  getValidStrDate,
  formatDate,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import { useProcessingStore } from "../../store/useProcessingStore";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter, useRoute } from "vue-router";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

// 添付ファイルのinterface
interface ContentsFile {
  rowNo: number;
  fileName: string;
  file: File | null;
  fileUrl: string | null;
  isUpload: boolean;
}

interface BannerData {
  bannerKbn: string;
  bannerId: string;
  bannerName: string;
  bannerCaption: string;
  bannerImgFileName: string;
  bannerUrl: string;
  dispOrder: number;
  dispDtFrom: string;
  dispDtTo: string;
  bannerImageFileList: ContentsFile[];
}

class BannerRegConstants {
  static readonly API_URL_INITIAL_DISPLAY =
    "/api/BannerReg/getRegFormInitialData";
  static readonly API_URL_GET_BANNER = "/api/BannerReg/getBannerData";
  static readonly API_URL_CREATE_BANNER = "/api/BannerReg/createBanner";
  static readonly API_URL_UPDATE_BANNER = "/api/BannerReg/updateBanner";
}

export default defineComponent({
  name: "BannerRegComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    LoadingOverlay,
  },
  setup() {
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const router = useRouter();
    const route = useRoute();
    const paramBannerKbn = computed(() => route.query.bannerKbn as string); // パラメータ．コンテンツカテゴリID
    const paramBannerId = computed(() => route.query.bannerId as string); // パラメータ．コンテンツID
    const paramEditMode = computed(() => route.query.editMode as string); // パラメータ．編集モード
    const { logoutUser } = useUserStore();
    const bannerImgFileExtensions = [".jpg", ".png"]; // サムネイル画像ファイルの拡張子
    const uploadProgress = ref<number | null>(null); //
    const bannerImgFileInput = ref<HTMLInputElement | null>(null);
    const txtBannerName = ref<HTMLInputElement | null>(null);
    const isLoading = ref(false);

    let maxFileSize = 0; // ファイルアップロードの最大サイズ
    const agCode = ref(""); // ローカルストレージ．AGコード
    const userId = ref(""); // ローカルストレージ．ユーザーID

    const bannerData = ref<BannerData>({
      bannerKbn: "",
      bannerId: "",
      bannerName: "",
      bannerCaption: "",
      bannerImgFileName: "",
      bannerUrl: "",
      dispOrder: 0,
      dispDtFrom: "",
      dispDtTo: "",
      bannerImageFileList: [],
    });
    // 初期処理
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        outputDebugLogs("プロパティのバナー区分: " + paramBannerKbn.value);
        outputDebugLogs("プロパティのバナーID: " + paramBannerId.value);

        // 初期処理時はTrue
        isInitError.value = true;
        let response;
        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
        }

        if (isUpdateMode.value) {
          // 更新モード
          await getBannerData();
        } else {
          // 新規登録モード
          // 初期表示データ取得
          response = await apiAuthClient.post(
            BannerRegConstants.API_URL_INITIAL_DISPLAY,
            {
              systemKbn: AppConstants.SYSTEM_KBN_WITH,
              agCode: agCode.value,
              userId: userId.value,
            }
          );

          // バナー区分を格納しておく
          bannerData.value.bannerKbn = paramBannerKbn.value;
          outputDebugLogs(
            "bannerData.value.bannerKbn: " + bannerData.value.bannerKbn
          );

          // ファイルアップロード上限
          maxFileSize = response.data.maxFileSize;
          outputDebugLogs("maxFileSize: " + maxFileSize);
        }

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定

        // オブジェクト生成まで遅延させてフォーカスを設定できるようにする
        setTimeout(() => {
          outputDebugLogs("txtBannerName.value: " + txtBannerName.value);
          if (txtBannerName.value) {
            txtBannerName.value.focus();
            txtBannerName.value.select();
          }
        }, 100); // 適切な遅延時間を設定
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    });

    /**
     * バナーデータ取得
     */
    const getBannerData = async () => {
      // バナーデータ取得
      var response = await apiAuthClient.post(
        BannerRegConstants.API_URL_GET_BANNER,
        {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          agCode: agCode.value,
          userId: userId.value,
          bannerKbn: paramBannerKbn.value,
          bannerId: paramBannerId.value,
        }
      );

      // バナー情報を設定
      bannerData.value = response.data.bannerData;

      // 表示期間の形式を変更
      bannerData.value.dispDtFrom = formatDate(
        response.data.bannerData.dispDtFrom
      );
      bannerData.value.dispDtTo = formatDate(response.data.bannerData.dispDtTo);

      // ファイルアップロード上限
      maxFileSize = response.data.maxFileSize;
      outputDebugLogs("maxFileSize: " + maxFileSize);

      bannerData.value.bannerImageFileList = [];
    };

    /**
     * 更新モード判定
     */
    const isUpdateMode = computed(() => {
      return paramEditMode.value == AppConstants.AG_USER_EDIT_MODE_UPDATE;
    });

    /**
     * 戻るボタン押下
     */
    const onBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
        if (!isConfirm) {
          // いいえの場合
          return;
        }
        // バナー登録・変更 一覧画面へ遷移
        router.push({
          path: "/banner-touroku-list",
          query: {
            isResearch: "true",
          },
        });
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * クリアボタン押下
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      try {
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 確認ダイアログ表示
        const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
        if (!isConfirm) {
          // いいえの場合
          return;
        }

        // メッセージクリア
        errorMessage.value = "";

        if (isUpdateMode.value) {
          // 処理中フラグON
          processingStore.isProcessing = true;

          try {
            // バナー情報取得
            await getBannerData();
          } catch (error: unknown) {
            // エラー処理
            handleAxiosError(error);
          }
        } else {
          // 新規登録モードの場合
          bannerData.value = {
            bannerKbn: "",
            bannerId: "",
            bannerName: "",
            bannerCaption: "",
            bannerImgFileName: "",
            bannerUrl: "",
            dispOrder: 0,
            dispDtFrom: "",
            dispDtTo: "",
            bannerImageFileList: [],
          };
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 確定ボタン押下
     */
    const onFixed = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;
      // メッセージクリア
      errorMessage.value = "";

      try {
        // 入力チェック
        if (!validateInput()) {
          return;
        }

        const processingName = isUpdateMode.value ? "更新" : "登録";
        const apiUrl = isUpdateMode.value
          ? BannerRegConstants.API_URL_UPDATE_BANNER
          : BannerRegConstants.API_URL_CREATE_BANNER;

        // 確認ダイアログ表示
        const isConfirm = window.confirm(
          formatMessage(messages.CNF_0001, "バナー", processingName)
        );
        if (!isConfirm) {
          // いいえの場合
          return;
        }

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        try {
          // バナー画像ファイルをアップロード
          const result = await executeContentsFiles(
            bannerData.value.bannerImageFileList
          );

          // ファイルアップロードに失敗している場合
          if (!result) {
            scrollToTop();
            errorMessage.value = formatMessage(
              messages.ERR_SYS003,
              "ファイルアップロード"
            );
            return;
          }

          await apiAuthClient.post(apiUrl, getRequestInput());

          // 完了メッセージ表示
          alert(formatMessage(messages.INF_0001, "バナー", processingName));

          // バナー登録・変更 一覧画面へ遷移
          router.push({
            path: "/banner-touroku-list",
            query: {
              isResearch: "true",
            },
          });
        } catch (error: unknown) {
          // エラー処理
          handleAxiosError(error);
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**
     * 登録・更新APIのリクエストデータを返却します。
     */
    const getRequestInput = (): object => {
      return {
        systemKbn: AppConstants.SYSTEM_KBN_WITH,
        agCode: agCode.value,
        userId: userId.value,
        bannerKbn: bannerData.value.bannerKbn,
        bannerId: bannerData.value.bannerId,
        bannerName: sanitizeInput(bannerData.value.bannerName),
        bannerCaption: sanitizeInput(bannerData.value.bannerCaption),
        bannerImgFileName: sanitizeInput(bannerData.value.bannerImgFileName),
        bannerUrl: sanitizeInput(bannerData.value.bannerUrl),
        dispOrder: bannerData.value.dispOrder,
        dispDtFrom: getValidStrDate(bannerData.value.dispDtFrom),
        dispDtTo: getValidStrDate(bannerData.value.dispDtTo),
        bannerImageFileList: bannerData.value.bannerImageFileList,
      };
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, true);
    };

    /** バナー画像クリア */
    const onBannerImglClear = () => {
      bannerData.value.bannerImgFileName = "";
      bannerData.value.bannerImageFileList = [];
    };

    /**
     * ファイルサイズチェック
     */
    const isFileSize = (file: File | null): boolean => {
      return (file?.size ?? 0) <= maxFileSize;
    };

    /**
     * ファイル拡張子チェック
     * @param file ファイル
     * @param extensions 拡張子
     */
    const isFileExtensions = (
      file: File | null,
      ...extensions: string[]
    ): boolean => {
      return extensions.some((extension) =>
        file?.name.toLowerCase().endsWith(extension)
      );
    };

    /* 添付ファイルアップロードボタン押下時
     * @param trigger
     */
    const onContentsFileUpload = () => {
      if (bannerImgFileInput.value) {
        bannerImgFileInput.value.click();
      }
    };

    /**
     * 添付ファイル選択時
     * @param event
     */
    const handleContentsFileSelected = (event: Event) => {
      contentsFileSelected(event);
    };

    /**
     * 添付ファイル選択時
     * @param event
     * @param trigger
     */
    const contentsFileSelected = (event: Event) => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      errorMessage.value = "";

      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];

      try {
        if (file) {
          const contentsFile = {
            rowNo: 1,
            fileName: file.name,
            file: file,
            fileUrl: null,
            isUpload: true,
          };

          // ファイルサイズチェック
          if (!isFileSize(contentsFile.file)) {
            errorMessage.value = formatMessage(
              messages.ERR_0024,
              maxFileSize / (1024 * 1024)
            );
            scrollToTop();
            return;
          }

          let messageId = "";
          let arg = "";

          if (
            !isFileExtensions(contentsFile.file, ...bannerImgFileExtensions)
          ) {
            // 拡張子チェック
            messageId = messages.ERR_0027;
            arg = "画像ファイル";
          } else if (!checkFileName(file.name.toLowerCase())) {
            // ファイル名チェック
            messageId = messages.ERR_0025;
            arg = "画像ファイル名";
          }

          // エラーがある場合
          if (messageId) {
            errorMessage.value = formatMessage(messageId, arg);
            scrollToTop();
            return;
          }

          bannerData.value.bannerImgFileName = contentsFile.fileName;
          bannerData.value.bannerImageFileList.push(contentsFile);
        }
      } finally {
        // ファイルを未選択状態にする
        fileInput.value = "";
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 入力チェック
     */
    const validateInput = (): boolean => {
      const messageList = ref<string[]>([]);

      // バナー名
      const sanitizedBannerName = sanitizeInput(bannerData.value.bannerName);
      if (!sanitizedBannerName) {
        // 必須チェック
        messageList.value.push(formatMessage(messages.ERR_0001, "バナー名"));
      } else if (!hasNoGaiji(sanitizedBannerName)) {
        // 使用不可文字チェック
        messageList.value.push(formatMessage(messages.ERR_0026, "バナー名"));
      }

      // リンクURL
      const sanitizedLinkUrl = sanitizeInput(bannerData.value.bannerUrl);
      if (!sanitizedLinkUrl) {
        // 必須チェック
        messageList.value.push(formatMessage(messages.ERR_0001, "リンクURL"));
      } else if (!hasNoGaiji(sanitizedLinkUrl)) {
        // 使用不可文字チェック
        messageList.value.push(formatMessage(messages.ERR_0026, "リンクURL"));
      }

      // キャプション
      const sanitizedCaption = sanitizeInput(bannerData.value.bannerCaption);
      if (!hasNoGaiji(sanitizedCaption)) {
        // 使用不可文字チェック
        messageList.value.push(
          formatMessage(messages.ERR_0026, "キャプション")
        );
      }

      // 表示期間
      // 大小チェック
      const keisaiKikanStart = bannerData.value.dispDtFrom;
      const keisaiKikanEnd = bannerData.value.dispDtTo;
      if (keisaiKikanStart && keisaiKikanEnd) {
        if (new Date(keisaiKikanStart) > new Date(keisaiKikanEnd)) {
          messageList.value.push(
            formatMessage(messages.ERR_0005, "表示期間FROM", "表示期間TO")
          );
        }
      }

      // バナー画像
      bannerData.value.bannerImageFileList
        .filter((contentsFile) => contentsFile.file != null)
        .forEach((contentsFile) => {
          // ファイルチェック
          validateContentsFile(messageList.value, contentsFile);
        });

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**
     * ファイルチェック
     * @param contentsFile
     */
    const validateContentsFile = (
      messageList: string[],
      contentsFile: ContentsFile
    ): boolean => {
      let isErr = false;

      // ファイルサイズチェック
      if (!isFileSize(contentsFile.file)) {
        messageList.push(
          (errorMessage.value = formatMessage(
            messages.ERR_0024,
            maxFileSize / (1024 * 1024)
          ))
        );
        isErr = true;
      }

      // 拡張子チェック
      if (!isFileExtensions(contentsFile.file, ...bannerImgFileExtensions)) {
        // 拡張子チェック
        messageList.push(
          (errorMessage.value = formatMessage(
            messages.ERR_0027,
            "バナーファイル"
          ))
        );
        isErr = false;
      }

      return !isErr;
    };

    /**
     * ファイルアップロード実行
     * @param contentsFileList
     */
    async function executeContentsFiles(contentsFileList: ContentsFile[]) {
      let result = true;

      for (const contentsFile of contentsFileList) {
        if (contentsFile.isUpload) {
          try {
            await uploadContentsFile(contentsFile);
          } catch (error) {
            result = false;
            break;
          }
        }
      }

      return result;
    }

    /**
     * ファイルアップロード処理
     * @param item
     */
    const uploadContentsFile = (contentsFile: ContentsFile): Promise<void> => {
      return new Promise((resolve, reject) => {
        if (!contentsFile.file) {
          reject("No file selected");
          return;
        }

        // ローカルストレージからトークンを取得
        const token = localStorage.getItem(AppConstants.TOKEN_SESSION_NAME);
        if (!token) {
          reject("No token found. Please log in.");
          return;
        }

        const upload = new tus.Upload(contentsFile.file, {
          // ファイルアップロードのエンドポイント
          endpoint: process.env.VUE_APP_FILE_UPLOAD_ENDPOINT,
          headers: {
            Authorization: `Bearer ${token}`,
          },
          metadata: {
            filename: contentsFile.file.name,
            filetype: contentsFile.file.type,
            agcode: agCode.value,
            userid: userId.value,
          },
          onError: (error) => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.error("Upload failed:", error);
            }
            reject(error);
          },
          onProgress: (bytesUploaded, bytesTotal) => {
            uploadProgress.value = Math.floor(
              (bytesUploaded / bytesTotal) * 100
            );
          },
          onSuccess: () => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.log("Upload finished:", upload.url);
            }
            // ファイルURLを保存
            contentsFile.fileUrl = upload.url;
            resolve();
          },
        });

        upload.start();
      });
    };

    return {
      isInitError,
      isDataFetched,
      errorMessage,
      isKaunetAdmin,
      isUpdateMode,
      bannerData,
      onBack,
      onClear,
      onFixed,
      onBannerImglClear,
      bannerImgFileExtensions,
      bannerImgFileInput,
      handleContentsFileSelected,
      onContentsFileUpload,
      txtBannerName,
      AppConstants,
      isLoading,
    };
  },
});
</script>

<style scoped>
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.form-control-title {
  text-align: center;
  background-color: lightgrey;
  border-radius: 0.25rem;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
.flex-container {
  display: flex;
  justify-content: flex-end;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
table {
  border-collapse: separate;
}
</style>
